import React from "react";
import AC from "../../PicesForPages/AffordCalculator.webp";
import AffordCalculator from "../CalculatorAndChart/affordCalculator";

function AffordabilityCalculator() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={AC}
          alt="ACImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Affordability Calculator</span>
        </div>
      </div>
      <AffordCalculator />
    </div>
  );
}

export default AffordabilityCalculator;
